export interface Product {
  id: number;
  name: string;
  image: string;
  image2?: string;
  price: number;
  originalPrice: number;
  discount: number;
  rating: number;
  reviews: string;
  delivery: string;
}

export const products: Product[] = [
{
  id: 1,
  name: "Big Basket Offer today online: Buy 20kg ashirwad atta+1 kg Besan + 5 kg sugar + 5 kg mustard oil",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1020cb747-1777616861351.png",
  image2: "https://img.rocket.new/generatedImages/rocket_gen_img_1020cb747-1777616861351.png",
  price: 499,
  originalPrice: 1099,
  discount: 55,
  rating: 5,
  reviews: "2,165",
  delivery: "Free delivery"
},
{
  id: 2,
  name: "Big Basket Offer today online: Get Combo of 1kg Kaju and 1 kg Badam",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b7df9bc5-1775141900586.png",
  image2: "https://img.rocket.new/generatedImages/rocket_gen_img_1b7df9bc5-1775141900586.png",
  price: 299,
  originalPrice: 899,
  discount: 67,
  rating: 5,
  reviews: "956",
  delivery: "Free delivery"
},
{
  id: 3,
  name: "Big Basket Offer Today 9 Combo packs ' 10 kg Ashirwaad atta , 5 kg india gate basmati rice , fortune oil 5 L , Surf Excel 5 kg and more 5Kg",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1020cb747-1777616861351.png",
  image2: "https://img.rocket.new/generatedImages/rocket_gen_img_1020cb747-1777616861351.png",
  price: 699,
  originalPrice: 2478,
  discount: 72,
  rating: 5,
  reviews: "654",
  delivery: "Free delivery"
},
{
  id: 4,
  name: "May Offer - Get 4Kg Dry Fruit Mix Combo",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bb2f3c36-1772382170895.png",
  image2: "https://img.rocket.new/generatedImages/rocket_gen_img_1bb2f3c36-1772382170895.png",
  price: 399,
  originalPrice: 999,
  discount: 60,
  rating: 5,
  reviews: "1,714",
  delivery: "Free delivery"
},
{
  id: 5,
  name: "Big Basket Offer Today 9 Combo packs ' 10 kg Ashirwaad atta , 5 kg india gate basmati rice , fortune oil 5 L , Surf Excel 5 kg and more 5Kg",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1020cb747-1777616861351.png",
  image2: "https://img.rocket.new/generatedImages/rocket_gen_img_1020cb747-1777616861351.png",
  price: 699,
  originalPrice: 2478,
  discount: 72,
  rating: 4,
  reviews: "4,877",
  delivery: "Free delivery"
},
{
  id: 6,
  name: "Big Basket Offer Today 9 Combo packs ' 10 kg Ashirwaad atta , 5 kg india gate basmati rice , fortune oil 5 L , Surf Excel 5 kg and more 5Kg",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1020cb747-1777616861351.png",
  image2: "https://img.rocket.new/generatedImages/rocket_gen_img_1020cb747-1777616861351.png",
  price: 369,
  originalPrice: 3999,
  discount: 91,
  rating: 5,
  reviews: "8,366",
  delivery: "Free delivery"
},
{
  id: 7,
  name: "4 combo pack' india basmati 10kg 'tata agni 500g ashirwaad atta 10kg fortune sugar 5kg",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1751dbf3b-1783349913361.png",
  image2: "https://img.rocket.new/generatedImages/rocket_gen_img_1751dbf3b-1783349913361.png",
  price: 595,
  originalPrice: 2789,
  discount: 79,
  rating: 5,
  reviews: "3,681",
  delivery: "Free delivery"
},
{
  id: 8,
  name: "Aashirvaad Atta 5kg, India gate basmati rice 5kg, Fortune Suger 5kg, Lipton 1kg TATA Agni 1Kg, Super Sarvottam Refined Rice Bran Oil 1L",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_15ae77e89-1766309506603.png",
  image2: "https://img.rocket.new/generatedImages/rocket_gen_img_15ae77e89-1766309506603.png",
  price: 369,
  originalPrice: 3999,
  discount: 91,
  rating: 3,
  reviews: "6,756",
  delivery: "Free delivery"
},
{
  id: 9,
  name: "Big Basket Offer today: Combo of 5 kg Fortune oil+ 5 kg sugar+ 5 kg Basmati rice",
  image: "/assets/images/298_bbb_-1783350245630.png",
  image2: "/assets/images/298_bbb_-1783350245630.png",
  price: 298,
  originalPrice: 999,
  discount: 70,
  rating: 5,
  reviews: "8,742",
  delivery: "Free delivery"
},
{
  id: 10,
  name: "Big Basket Offer today online: Get Combo of 5 liter Fortune Oil and 5 Litre Mustard Oil",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c1899d66-1773216918113.png",
  image2: "https://img.rocket.new/generatedImages/rocket_gen_img_1c1899d66-1773216918113.png",
  price: 386,
  originalPrice: 1286,
  discount: 69,
  rating: 4,
  reviews: "1,483",
  delivery: "Free delivery"
},
{
  id: 11,
  name: "Big Basket Offer today online: Buy 20kg ashirwad atta+1 kg Besan + 5 kg sugar + 5 kg mustard oil",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1020cb747-1777616861351.png",
  image2: "https://img.rocket.new/generatedImages/rocket_gen_img_1020cb747-1777616861351.png",
  price: 499,
  originalPrice: 1099,
  discount: 55,
  rating: 3,
  reviews: "4,522",
  delivery: "Free delivery"
},
{
  id: 12,
  name: "Big Basket Offer today online: Get Combo of 1kg Kaju and 1 kg Badam",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b7df9bc5-1775141900586.png",
  price: 199,
  originalPrice: 1988,
  discount: 90,
  rating: 5,
  reviews: "11,537",
  delivery: "Free delivery"
},
{
  id: 13,
  name: "Big Basket Offer today online: Get Basmati Rice 5kg+ Fortune Oil 5L",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_114bb414d-1766309506272.png",
  image2: "https://img.rocket.new/generatedImages/rocket_gen_img_114bb414d-1766309506272.png",
  price: 299,
  originalPrice: 996,
  discount: 75,
  rating: 4,
  reviews: "9,614",
  delivery: "Free delivery"
},
{
  id: 14,
  name: "Big Basket Combo: Fortune Basmati Rice 5kg, Oil 5L, Sugar 5kg & Besan 2kg",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_140f74d6f-1783349914033.png",
  price: 499,
  originalPrice: 1663,
  discount: 70,
  rating: 4,
  reviews: "9,614",
  delivery: "Free delivery"
}];